import styled from 'styled-components';
import { Icon } from 'react-icons-kit';
import { ic_dashboard } from 'react-icons-kit/md/ic_dashboard';
import { ic_receipt } from 'react-icons-kit/md/ic_receipt';
import { ic_verified_user } from 'react-icons-kit/md/ic_verified_user';
import { ic_settings } from 'react-icons-kit/md/ic_settings';

export enum OpoNavKey {
    ActionCenter = 'action-center',
    Billing = 'billing',
    ContractsDocuments = 'contracts-documents',
    Settings = 'settings'
}

const navItems = [
    { key: OpoNavKey.ActionCenter, label: 'Action Center', icon: ic_dashboard },
    { key: OpoNavKey.Billing, label: 'Billing', icon: ic_receipt },
    { key: OpoNavKey.ContractsDocuments, label: 'Contracts and Documents', icon: ic_verified_user },
    { key: OpoNavKey.Settings, label: 'Settings', icon: ic_settings }
];

const NavContainer = styled.nav`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px 12px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
`;

const NavHeader = styled.div`
    padding: 4px 12px 16px;
    margin-bottom: 8px;
    border-bottom: 1px solid #f0f2f5;
`;

const NavEyebrow = styled.div`
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #8a94a6;
`;

const NavTitle = styled.div`
    margin-top: 2px;
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const NavList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const NavButton = styled.button<{ $active: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 10px 12px;
    border: none;
    border-radius: 8px;
    background: ${p => p.$active ? '#eaf2fb' : 'transparent'};
    color: ${p => p.$active ? '#1d5a96' : '#4b5563'};
    font-size: 14px;
    font-weight: ${p => p.$active ? 600 : 500};
    text-align: left;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 8px;
        bottom: 8px;
        width: 3px;
        border-radius: 0 3px 3px 0;
        background: ${p => p.$active ? '#337ab7' : 'transparent'};
    }

    &:hover {
        background: ${p => p.$active ? '#eaf2fb' : '#f3f4f6'};
        color: ${p => p.$active ? '#1d5a96' : '#111827'};
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        box-shadow: 0 0 0 2px rgba(51, 122, 183, 0.4);
    }
`;

const IconWrapper = styled.span<{ $active: boolean }>`
    display: inline-flex;
    color: ${p => p.$active ? '#337ab7' : '#9ca3af'};
`;

interface IProps {
    title: string,
    activeKey: string,
    onSelect: (key: OpoNavKey) => void
}

const LandingNav = ({ title, activeKey, onSelect }: IProps) => (
    <NavContainer aria-label='OPO navigation'>
        {/* <NavHeader>
            <NavEyebrow>OPO Portal</NavEyebrow>
            <NavTitle title={title}>{title}</NavTitle>
        </NavHeader> */}
        <NavList>
            {navItems.map(item => {
                const active = item.key === activeKey;
                return (
                    <li key={item.key}>
                        <NavButton type='button' $active={active} aria-current={active ? 'page' : undefined} onClick={() => onSelect(item.key)}>
                            <IconWrapper $active={active}><Icon icon={item.icon} size={20} /></IconWrapper>
                            {item.label}
                        </NavButton>
                    </li>
                );
            })}
        </NavList>
    </NavContainer>
);

export default LandingNav;
